import { useState } from 'react';
import IconAdd from '../../../components/icons/IconAdd';
import IconDelete from '../../../components/icons/IconDelete';
import RichTextEditor from '../../../components/RichTextEditor';
import { renderRichText } from '../../../utils/richText';
import { safeParseConfig } from '../blockConfig';

const DEFAULT = { style: 'bullet', items: [''] };

export default function ListBlockEditor({ block, onSave, onCancel }) {
   const initial = safeParseConfig(block.config, DEFAULT);
   const [style, setStyle] = useState(initial.style || 'bullet');
   const [items, setItems] = useState(initial.items && initial.items.length ? initial.items : ['']);

   const updateItem = (i, value) => setItems(prev => prev.map((it, idx) => idx === i ? value : it));
   const addItem = () => setItems(prev => [...prev, '']);
   const removeItem = (i) => setItems(prev => prev.filter((_, idx) => idx !== i));

   const handleSave = () => {
      const cleanItems = items.map(it => it.trim()).filter(Boolean);
      onSave({ config: JSON.stringify({ style, items: cleanItems }) });
   };

   return (
      <div className='exercise-block-list-editor'>
         <div className='exercise-block-list-style-row'>
            <label><input type='radio' checked={style === 'bullet'} onChange={() => setStyle('bullet')} /> Маркований</label>
            <label><input type='radio' checked={style === 'number'} onChange={() => setStyle('number')} /> Нумерований</label>
         </div>
         {items.map((item, i) => (
            <div className='exercise-block-list-item-row' key={i}>
               <RichTextEditor rows={1} value={item} placeholder={'Пункт ' + (i + 1)} onChange={value => updateItem(i, value)} />
               <div className='exercise-block-item-remove-btn' onClick={() => removeItem(i)}><IconDelete style={{fill:'#e0876c', width:14, height:14, margin:0}} /></div>
            </div>
         ))}
         <div className='exercise-block-item-add-btn' onClick={addItem}><IconAdd /> Додати пункт</div>
         <div className='exercise-block-editor-actions'>
            <button type='button' className='exercise-block-save-btn' onClick={handleSave}>Зберегти</button>
            <button type='button' className='exercise-block-cancel-btn' onClick={onCancel}>Скасувати</button>
         </div>
      </div>
   );
}

export function renderListPreview(block) {
   const cfg = safeParseConfig(block.config, DEFAULT);
   const items = (cfg.items || []).filter(it => it && it.trim());
   if(items.length === 0) return <span className='exercise-block-empty-hint'>Порожньо</span>;
   const Tag = cfg.style === 'number' ? 'ol' : 'ul';
   return <Tag className='exercise-block-list-preview'>{items.map((it, i) => <li key={i}>{renderRichText(it)}</li>)}</Tag>;
}
